import { ReactElement, Suspense } from 'react';

import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { EngageSettingsNavigation, LoadingPanel } from '../components/utils';

export const EngageSettingsLayout = (): ReactElement => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      }}
    >
      <Box
        sx={{
          minHeight: 48,
          borderRight: 1,
          borderColor: 'divider',
        }}
      >
        {/* Tab navigation */}
        <EngageSettingsNavigation />
      </Box>

      <Suspense fallback={<LoadingPanel />}>
        <Outlet />
      </Suspense>
    </Box>
  );
};
